import { useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { signalTypeMap } from "app/pages/sales-intelligence/domain/signals/types/signal";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import {
    selectIntentSelectedTopics,
    selectIsSelectedTopicFetching,
} from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";

export const IntentSignalTypeSectionMeta = () => {
    const { translate } = useTranslate();
    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const isSelectedTopicsFetching = useSelector(selectIsSelectedTopicFetching);

    if (signalsService.isSignalTypeLocked(signalTypeMap.intent) || isSelectedTopicsFetching) {
        return null;
    }

    const numIntentTopics = salesSettingsHelper.getNumIntentTopics();

    return (
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[250]}
        >
            {translate("si.intent.management.selected-topics")}:{selectedTopics.length}/{numIntentTopics}
        </Text>
    );
};
